import React from 'react';

export const CompetencyLevel = ({ level, onChange, readonly = false }) => {
  const dots = [1, 2, 3, 4, 5];

  return (
    <div className="competency-level" data-testid="competency-level">
      {dots.map((dot) => (
        <button
          key={dot}
          type="button"
          className={`level-dot ${dot <= level ? 'filled' : ''}`}
          onClick={() => !readonly && onChange && onChange(dot)}
          disabled={readonly}
          data-testid={`level-dot-${dot}`}
          aria-label={`Level ${dot}`}
        />
      ))}
      <span className="ml-2 text-sm text-muted-foreground">{level}/5</span>
    </div>
  );
};

export const CompetencyDotsDisplay = ({ level }) => {
  return (
    <div className="flex items-center gap-1" data-testid="competency-dots-display">
      {[1, 2, 3, 4, 5].map((dot) => (
        <span
          key={dot}
          className={`text-lg ${dot <= level ? 'competency-dot-filled' : 'competency-dot-empty'}`}
        >
          ●
        </span>
      ))}
    </div>
  );
};
